export const notificationDuration = {
  success: 2500,
  warning: 7500,
  error: 7500,
};

/**
 * A sign-in lasts at most this long (contractual maximum session of 60
 * minutes). It must match refresh_token_validity of the Cognito app client
 * (infrastructure/shared/modules/cognito_user_pool/cognito_client.tf): after it,
 * Cognito no longer refreshes the tokens.
 */
export const sessionLifetimeMinutes = 60;
export const sessionEndWarningMinutes = 5;

/**
 * Without keyboard, mouse, touch or navigation for this long the app signs the
 * user out (idle timeout of the 2023 pen test, finding 07), with a warning
 * this many minutes before. Activity in another tab of the app counts too.
 */
export const idleTimeoutMinutes = 30;
export const idleWarningMinutes = 2;

/**
 * The sign-out waits at most this long for the API to record it (method
 * signOut), then signs out at Cognito and in the browser anyway.
 */
export const signOutRequestTimeoutMs = 5000;
